import { Confirmation, Success } from './components';

const ClosePortfolioFlow = {
  Confirmation,
  Success,
};

export { ClosePortfolioFlow };
